<template>
  <div class="caring-calendar">
    <div class="caring-calendar-header">
      <span @click="handlePrev">
        <i class="el-icon-arrow-left"></i>
      </span>
      <DatePicker
        :open="monthOpen"
        :value="month"
        type="month"
        confirm
        :clearable="false"
        @on-change="handleMonthChange"
        @on-clear="handleMonthClear"
        @on-ok="handleMonthOk"
      >
        <div style="width: 220px; cursor: pointer;text-align: center">
          <div @click="openMonth">{{ curYear + '年' }} {{ curMonth + '月' }}</div>
        </div>
      </DatePicker>
      <span @click="handleNext">
        <i class="el-icon-arrow-right"></i>
      </span>
    </div>
    <el-calendar
      ref="calendar"
      v-model="value"
      :first-day-of-week="7"
      @input="handleInput"
    >
      <template v-slot:dateCell="{ data }">
        <p
          :class="[
            data.isSelected ? 'is-selected' : '',
            dots.find((dot) => dot.date === data.day) ? 'is-dot' : '',
            errors.find((error) => error.date === data.day) ? 'is-error' : '',
            successes.find(success => success.date === data.day) ? 'is-success' : ''
          ]"
        >
          {{ data.day.split("-").slice(2).join("-") }}
        </p>
      </template>
    </el-calendar>
  </div>
</template>
<script>
import { formatDate } from "../utils/date";
export default {
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
    successes: {
      type: Array,
      default: () => []
    },
    dots: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      value: new Date(),
      monthOpen: false,
      month: "",
    };
  },
  computed: {
    range() {
      let year = this.value.getFullYear();
      let month = this.value.getMonth() + 1;
      month = month >= 10 ? month : "0" + month;
      let start = `${year}-${month}-01`;
      let dateLength = new Date(year, month, 0).getDate();
      let end = `${year}-${month}-${dateLength}`;
      return [start, end];
    },
    curYear() {
      const year = new Date(this.value).getFullYear();
      return year;
    },
    curMonth() {
      const month = new Date(this.value).getMonth() + 1;
      return month;
    },
  },
  methods: {
    init() {
      this.$emit("change-month", formatDate(this.value), this.range);
    },
    handleMonthChange(date) {
      this.month = date;
    },
    handleMonthOk() {
      let date = new Date(this.value).getDate();
      date = date >= 10 ? date : '0' + date;
      if (typeof this.month === 'string') {
        this.value = new Date(this.month + '-' + date);
        this.$emit("change-month", formatDate(this.value), this.range);
      }
      this.monthOpen = false;
    },
    handleMonthClear() {
      this.monthOpen = false;
      this.month = new Date(this.value);
    },
    openMonth() {
      this.monthOpen = true;
      this.month = new Date(this.value);
    },
    handleInput() {
      this.$emit("change-date", formatDate(this.value), this.range);
    },
    handlePrev() {
      debugger
      let year = this.value.getFullYear();
      let month = this.value.getMonth();
      let date = this.value.getDate();
      let dateLength = new Date(year, month, 0).getDate();
      if (month == 0) {
        year = year - 1;
        month = 12;
      }
      if (date > dateLength) {
        date = 1;
      }

      this.value = new Date(`${year}/${month}/${date}`);
      this.$emit("change-month", formatDate(this.value), this.range);
    },
    handleNext() {
      let year = this.value.getFullYear();
      let month = this.value.getMonth() + 2;
      let date = this.value.getDate();
      if (month == 13) {
        year = year + 1;
        month = 1;
      }
      let dateLength = new Date(year, month, 0).getDate();
      if (date > dateLength) {
        date = 1;
      }
      this.value = new Date(`${year}/${month}/${date}`);
      this.$emit("change-month", formatDate(this.value), this.range);
    },
  },
};
</script>
<style lang="less">
.caring-calendar {
  .ivu-date-picker-cells-month .ivu-date-picker-cells-cell-focused, .ivu-date-picker-cells-year .ivu-date-picker-cells-cell-focused{
    background: #fff;
  }

  .el-calendar__body {
    padding: 12px 0 10px;
  }
  .caring-calendar-header {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #738399;
    font-weight: 500;
    > span {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      font-size: 18px;
    }
    i {
      cursor: pointer;
      color: #738399;
      font-weight: 700;
      font-size: 20px;
      &:hover {
        color: #333;
      }
    }
  }
  .is-dot, .is-error, .is-success{
    position: relative;
    &::after {
      position: absolute;
      left: 50%;
      bottom: -7px;
      transform: translateX(-50%);
      content: " ";
      width: 6px;
      height: 6px;
      border-radius: 50%;
    }
  }
  .is-dot {
    &::after {
      background: #c0c4cc;
    }
  }
  .is-error {
    &::after {
      background: #f97070;
    }
  }
  .is-success{
    &::after {
      background: #3eca9a;
    }
  }
  .el-calendar__header {
    display: none;
  }
  .el-calendar-table thead th {
    color: #84abf5;
    font-weight: 600;
  }
  .el-calendar-table .el-calendar-day {
    text-align: center;
    height: auto;
    &:hover {
      background: #fff;
      p {
        background-color: #f1f8fe;
      }
    }
    > p {
      width: 32px;
      height: 32px;
      line-height: 32px;
      border-radius: 50%;
    }
  }
  .el-calendar-table tr td {
    border: none;
  }
  .el-backtop,
  .el-calendar-table td.is-today {
    color: #515a6e;
  }
  .el-calendar-table td.is-selected {
    background: #fff;

    p.is-selected {
      color: #fff;
      background-color: #4286f1;
    }
  }
  .el-calendar-table tr td:first-child {
    border-left: none;
  }
  .el-calendar-table tr:first-child td {
    border-top: none;
  }
}
</style>
